'use client'

import { AlertCircle } from 'lucide-react'

import { cn } from '@/lib/utils'

interface SignInErrorNotificationProps {
  message: string
  className?: string
}

export function SignInErrorNotification({
  message,
  className,
}: SignInErrorNotificationProps) {
  return (
    <div
      role="alert"
      aria-live="polite"
      className={cn(
        'animate-in fade-in slide-in-from-bottom-2 fill-mode-both flex items-start gap-2.5 border-l-4 border-destructive bg-destructive/10 px-3.5 py-3 text-sm text-destructive duration-500',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span className="text-pretty leading-relaxed font-medium">{message}</span>
    </div>
  )
}
